/**
 * Minimal loading indicator shown during SPA route transitions.
 *
 * Renders a thin animated bar at the top of the viewport (like GitHub's
 * page loading indicator). Non-intrusive — the previous page content
 * remains visible underneath via TanStack Router's pending behavior.
 */
export function RouteLoadingIndicator() {
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50">
      <div className="h-0.5 w-full overflow-hidden bg-gray-200/50">
        <div className="animate-loading-bar h-full bg-violet-500" />
      </div>
    </div>
  );
}
